import { depascalize } from "sprint-common-web";

import { OnPremOrderStatus } from "../../../common/types/OnPremOrderStatus";

export const getAvailableOnPremOrderStatuses = (currStatus: OnPremOrderStatus): OnPremOrderStatus[] => {
    switch (currStatus) {
        case OnPremOrderStatus.Ordered:
            return [
                OnPremOrderStatus.PartialAssetAssigned,
                OnPremOrderStatus.AssetAssigned,
                OnPremOrderStatus.Encoded,
                OnPremOrderStatus.Recalled
            ];
        case OnPremOrderStatus.PartialAssetAssigned:
            return [
                OnPremOrderStatus.Ordered,
                OnPremOrderStatus.AssetAssigned,
                OnPremOrderStatus.Encoded,
                OnPremOrderStatus.Recalled
            ];
        case OnPremOrderStatus.AssetAssigned:
            return [
                OnPremOrderStatus.PartialAssetAssigned,
                OnPremOrderStatus.Ordered,
                OnPremOrderStatus.Encoded,
                OnPremOrderStatus.Recalled
            ];
        case OnPremOrderStatus.Rejected:
            return [OnPremOrderStatus.Encoded, OnPremOrderStatus.Recalled];
        case OnPremOrderStatus.Encoded:
        case OnPremOrderStatus.Recalled:
            return [OnPremOrderStatus.ReadyToSend];
        case OnPremOrderStatus.ReadyToSend:
            return [OnPremOrderStatus.SentToOem];
        default:
            return [];
    }
};

export const allowedOnPremOrderStatuses: OnPremOrderStatus[] = [
    OnPremOrderStatus.Ordered,
    OnPremOrderStatus.PartialAssetAssigned,
    OnPremOrderStatus.AssetAssigned,
    OnPremOrderStatus.Recalled,
    OnPremOrderStatus.Encoded,
    OnPremOrderStatus.ReadyToSend,
    OnPremOrderStatus.SentToOem
];

export const mapOnPremOrderStatusName = (status: OnPremOrderStatus): string => {
    if (status === OnPremOrderStatus.SentToOem) return "Sent To OEM";
    return depascalize(OnPremOrderStatus[status]);
};
